import FIPModel from "../Models/FIPModel";
import { DiscoverAccountObject } from "../Models/Response/Account/DiscoverAccount";
import Consent from "../Models/Response/Consent/GetAllConsent";
import { AuthenticationState } from "./Reducer/authenticationReducer";

export const getFIP = (fips: FIPModel[]) => ({
  type: "ADD_FIP",
  payload: {
    fips,
  },
});

export const discoverAccount = (accounts: DiscoverAccountObject[]) => ({
  type: "DISCOVER_ACCOUNT",
  payload: {
    accounts,
  },
});

export const saveConsent = (consent: Consent) => ({
  type: "SAVE_CONSENT",
  payload: {
    consent,
  },
});

export const saveToken = (authenticationState: AuthenticationState) => ({
  type: "SAVE_TOKEN",
  payload: {
    ...authenticationState,
  },
});

export const startLoader = () => ({
  type: "START_SEARCH",
});

export const pauseLoader = () => ({
  type: "FINISH_SEARCH",
});

export const userInformation = (user: any) => ({
  type: "STORE_USER",
  payload: {
    user,
  },
});
